import dayjs from "dayjs";

export const dateDayMonth = (date: Date) => {
    return dayjs(date)?.format("DD MMM");
};

export const dateColumnDayMonthFormat = (date: Date) => {
    return dayjs(date)?.format("ddd, DD MMM");
};

export const dateFormat = (date: Date, format: string = "YYYY-MM-DD") => {
    return dayjs(date)?.format(format);
};

export const dateFormatStandard = (date: Date, format: string = "DD-MM-YYYY") => {
    return dayjs(date)?.format(format);
};

export const formatCost = (num: number, fix: number) => {
    var p = num?.toFixed(fix)?.split(".");
    return p[0].split("").reduceRight(function (acc, num, i, orig) {
        if ("-" === num && 0 === i) {
            return num + acc;
        }
        var pos = orig.length - i - 1
        return num + (pos && !(pos % 3) ? "," : "") + acc;
    }, "") + (p[1] ? "." + p[1] : "");
}

